
export const simulation = {
  'simulation.title': 'Simuler un scénario',
  'simulation.tabs.form': 'Saisie de formulaire',
  'simulation.tabs.upload': 'Télécharger un document',
  'simulation.tabs.chat': 'Demander à AgriBot',
  'simulation.description': 'Explorez les correspondances potentielles de subventions sans créer de ferme',
  'simulation.form.heading': 'Détails de la ferme hypothétique',
  'simulation.form.region': 'Région',
  'simulation.form.country': 'Pays',
  'simulation.form.size': 'Taille de la ferme (hectares)',
  'simulation.form.irrigation': 'Méthode d\'irrigation',
  'simulation.form.certifications': 'Certifications',
  'simulation.form.carbonScore': 'Score carbone',
  'simulation.form.goals': 'Objectifs de durabilité',
  'simulation.form.submit': 'Trouver des subventions correspondantes',
  'simulation.upload.heading': 'Télécharger un document de ferme',
  'simulation.upload.description': 'Téléchargez un fichier PDF ou DOCX pour extraire les détails de la ferme',
  'simulation.upload.button': 'Télécharger un document',
  'simulation.upload.dragDrop': 'Glissez et déposez votre fichier ici ou cliquez pour parcourir',
  'simulation.upload.analyzing': 'Analyse du document...',
  'simulation.upload.complete': 'OCR terminé',
  'simulation.upload.extractedInfo': 'Informations extraites',
  'simulation.chat.heading': 'Décrivez votre projet',
  'simulation.chat.placeholder': 'Décrivez votre futur projet agricole...',
  'simulation.chat.hint': 'Par exemple: "Une ferme laitière passant à l\'agriculture biologique dans le sud-ouest de la Roumanie."',
  'simulation.chat.send': 'Envoyer',
  'simulation.results.heading': 'Résultats de la simulation',
  'simulation.results.matchCount': 'Résultats potentiels de subventions',
  'simulation.results.confidence': 'Confiance de correspondance',
  'simulation.results.saveFarm': 'Sauvegarder comme scénario hypothétique',
  'simulation.results.downloadReport': 'Télécharger le rapport de simulation (PDF)',
  'simulation.results.attachToFarm': 'Lier à une nouvelle ferme',
} as const;
